import wizard from 'common/pkgs/WizardRedux/modules'

export default wizard
